import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Home from "../../Pages/Home";
import Navbar from "../NavBar";
import CadastroPessoas from "../../Pages/CadastroPessoas";
import Login from "../../Pages/Login";
import BuscarPessoas from "../../Pages/BuscarPessoas";
import Footer from "../Footer";
import DetalharPessoa from "../../Pages/DetalharPessoas";
import EditarPessoas from "../../Pages/EditarPessoas";

function Rotas() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro-pessoas" element={<CadastroPessoas />} />
        <Route path="/editar-pessoas" element={<EditarPessoas />} />
        <Route path="/buscar-pessoas" element={<BuscarPessoas />}/>
        <Route path="/detalhar-pessoas" element={<DetalharPessoa />}/>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default Rotas;
